import { NgIf, NgIfContext } from '@angular/common';
import { Directive, OnInit, ViewContainerRef, TemplateRef, Optional, Attribute, inject } from '@angular/core';
import { ApplePayService } from './apple-pay.service';

@Directive({
    selector: '[ifApplePayAvailable]',
    standalone: true
})
export class IfApplePayAvailableDirective extends NgIf implements OnInit {
    constructor(
        _viewContainer: ViewContainerRef,
        templateRef: TemplateRef<NgIfContext<unknown>>,
        @Optional() @Attribute('applePayVersion') public version: number
    ) {
        super(_viewContainer, templateRef);
    }

    private applePayService = inject(ApplePayService);

    ngOnInit() {
        const version = Number(this.version);

        this.ngIf = this.applePayService.isAvailable && (!version || this.applePayService.isSupportedVersion(version));
    }
}
